export const APP_NAME = 'Saludari Assess';